module.exports = __webpack_public_path__ + "img/3-2.9d2930e6.png";